// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bia_tr","LeftMenu__link":"ir_b bia_vt bia_a bia_rc","LeftMenu__link__icon":"ir_c"};